// SPDX-License-Identifier: AGPL-3.0-or-later

import * as Modal from '@app/features/app/components/dialogs/Modal';
import {ModViewPanel} from '@app/features/moderation/components/profile/ModViewPanel';
import type {Profile} from '@app/features/user/models/Profile';
import type {User} from '@app/features/user/models/User';
import {observer} from 'mobx-react-lite';
import type React from 'react';

interface ModViewModalProps {
	user: User;
	profile?: Profile | null;
	guildId: string;
}

export const ModViewModal: React.FC<ModViewModalProps> = observer(({user, profile, guildId}) => {
	return (
		<Modal.Root size="small">
			<Modal.Header title={`Mod View: ${user.username}`} />
			<Modal.Content>
				<ModViewPanel user={user} profile={profile} guildId={guildId} />
			</Modal.Content>
		</Modal.Root>
	);
});
